import React from "react";

const PromotionCard = ({ className, icon, promotionProps, label }) => {
  const { description } = promotionProps;
  return (
    <div
      className={`p-[8px] rounded-[5px] flex items-center justify-between bg-hover-transaction-card dark:bg-base-deep-black ${className}`}
    >
      <div className="text-transaction-card-text dark:text-base-light-white flex items-center gap-[5px] font-medium text-2xl">
        {icon}
        <p className="text-base">{label}</p>
      </div>
      <p className="text-transaction-card-text dark:text-base-light-white text-lg">
        {description}
      </p>
    </div>
  );
};

export default PromotionCard;
